import React, { Component } from 'react'
import { ShippingParcelAttributes } from 'api/types'
import ParseDate from 'date-fns/parse'
import { format } from 'date-fns'
import { Form, Spacer } from '../index'
import Box from '../Box'
import Modal from './Modal'
import { __, T } from '../../translations/i18n'

interface Props {
  visible?: boolean
  title: string
  subtitle?: string
  isOpen?: boolean
  onConfirm: (phase: ShippingParcelAttributes | undefined) => void
  onClose: () => void
}

export default class InboundFieldsInputModal extends Component<Props> {
  state: {
    required: false
  } = {
    required: false,
  }

  submit = async (data: ShippingParcelAttributes) => {
    const { onClose, onConfirm } = this.props
    if (!data.ddtNumber || !data.ddtDate) {
      this.setState({ required: true })
      return
    }

    // ddtDate example: '2025-09-28T22:00:00.000Z'
    // convert ISO format to DATE
    const date = ParseDate(data.ddtDate, "yyyy-MM-dd'T'HH:mm:ss.SSSX", new Date())
    data.ddtDate = format(date, 'yyyy-MM-dd')
    this.setState({ required: false })
    onConfirm(data)
    onClose()
  }
  render() {
    const { isOpen, onClose, title } = this.props
    const { required } = this.state
    return (
      <Modal
        visible={isOpen ?? true}
        size="lg"
        onClose={() => {
          onClose()
        }}
      >
        <Box>
          <Modal.Title>{title}</Modal.Title>
          <Spacer />
          <Box flex center pb={20}>
            <span style={required ? { textDecoration: 'underline' } : {}}>{__(T.messages.ddt_fields_required)}</span>
          </Box>
          <Box flex center>
            <Form
              schema={[
                {
                  label: __(T.misc.ddt_code),
                  name: 'ddtNumber',
                  type: 'input',
                  focus: true,
                  required: true,
                },
                {
                  label: __(T.misc.ddt_date),
                  name: 'ddtDate',
                  type: 'date',
                  required: true,
                },
              ]}
              submitText={__(T.misc.next)}
              submitButtonStyle={{ marginTop: 180 }}
              onSubmit={this.submit}
              width={400}
            />
          </Box>
          <Spacer />
          <Spacer />
        </Box>
      </Modal>
    )
  }
}
